import fetch, { doGet, doPost } from '../../tools/axios'

export default {
  getLovebox (userRoleType, sort, category, page, perPage, cb = null, randomSeed = new Date().getTime()) {
    let query = ''
    if (!userRoleType) {
      userRoleType = []
    }

    if (userRoleType && !Array.isArray(userRoleType)) {
      userRoleType = userRoleType.split(',')
    }
    if (userRoleType.includes('VIPONLY') && userRoleType.includes('NOTVIP')) {
      userRoleType = userRoleType.filter(item => item !== 'VIPONLY')
    }

    if (userRoleType && userRoleType.length) {
      userRoleType.forEach(element => {
        switch (element) {
          case 'VIPONLY': query = query + `&memberFilter=VIPONLY`; break
          case 'NOTVIP': query = query + '&normal_only=1'; break
          case 'MINE': query = query + '&is_mine=1'; break
          case 'isTraceUser': query = query + '&is_trace_user=1'; break
          case 'ongoing': query = query + '&ongoing=1'; break
        }
      })
    }
    const params = query +
      `${sort ? `&sort=${sort}` : ''}` +
      `${category ? `&goods_class=${category}` : ''}` +
      `${randomSeed ? `&random_seed=${randomSeed}` : ''}`
    return fetch('get', `/love/provisions?page=${page}&perPage=${perPage}${params}`, {}, cb)
  },
  getLoveboxList ({ userRoleType, sort, category, page, perPage, randomSeed, ongoing, isTraceUser }) {
    let query = ''
    switch (userRoleType) {
      case 'VIPONLY': query = query + `&memberFilter=VIPONLY`; break
      case 'NOTVIP': query = query + '&normal_only=1'; break
      case 'MINE': query = query + '&is_mine=1'; break
      case 'isTraceUser': query = query + '&is_trace_user=1'; break
      case 'ongoing': query = query + '&ongoing=1'; break
    }

    const params = query +
      `${sort ? `&sort=${sort}` : ''}` +
      `${category ? `&goods_class=${category}` : ''}` +
      `${randomSeed ? `&random_seed=${randomSeed}` : ''}` +
      `${ongoing ? `&ongoing=1` : ''}` +
      `${isTraceUser ? '&is_trace_user=1' : ''}`
    return fetch('get', `/love/provisions?page=${page}&perPage=${perPage}${params}`, {})
  },
  getLoveboxInfo (id, cb) {
    return fetch('get', `/love/provisions/${id}`, {}, cb)
  },
  getLoveboxThanks (id, cb) {
    return fetch('get', `/thanks?love_provision_id=${id}&type=love&perPge=100`, {}, cb)
  },
  getLoveboxOrderItems (id, cb) {
    return fetch('get', `/love/love_order_items?provision_id=${id}&perPge=100`, {}, cb)
  },
  addlovboxItem (id, quantity, cb) {
    const data = {
      provision_id: id,
      quantity
    }
    return fetch('post', '/love/cart/add_item', {data}, cb)
  },
  getLoveCart (cb) {
    return fetch('get', '/love/cart/items', {}, cb)
  },
  updateCount (rowId, quantity, cb) {
    const data = {
      row_id: rowId,
      quantity
    }
    return fetch('post', '/love/cart/update_count', {data}, cb)
  },
  settleLoveCart (consignee, cellphone, address, cb) {
    const data = {
      consignee,
      cellphone,
      address
    }
    return fetch('post', '/love/cart/settlement', {data}, cb)
  },
  getMyShopBoxs (page, perPage, cb) {
    return fetch('get', `/love/boxes?perPage=${perPage || 4}&page=${page}`, {}, cb)
  },
  getMyLoveCollections (page, cb) {
    return fetch('get', `/love/collections?perPage=15&page=${page}`, {}, cb)
  },
  bookLoveCollections (params, cb) {
    return fetch('post', '/love/collections', {data: params}, cb)
  },
  removeItem (rowId, cb) {
    const data = {
      row_id: rowId
    }
    return fetch('post', '/love/cart/remove_item', {data}, cb)
  },
  contactCompany (data, cb) {
    return fetch('post', '/love/company/form', {data}, cb)
  },
  thanks (id, data, cb) {
    return fetch('post', `/love/love_order_items/${id}/thank_item`, {data}, cb)
  },
  getTrackingInfo (sn, type = 'hct') {
    return fetch('get', `/delivery/detail?type=${type}&waybill=${sn}`, {})
  },
  getUserLovebox (userId, status, page, perPage) { // 用戶贈送的GC代贈
    return doGet('/love/provisions', {
      user_id: userId,
      status,
      page,
      perPage
    })
  },
  getUserRequestLoveBoxes (userId, page, perPage) {
    return doGet('/love/love_order_items', {
      user_id: userId,
      page,
      perPage
    })
  },
  getToThankLoveboxTotal (cb) {
    return doGet('/love/my/received_no_thank_total', {}, cb)
  },
  getToThankLoveboxes (page, perPage, cb) {
    return doGet('/love/my/received_no_thank', {
      page,
      perPage
    }, cb)
  },
  getLoveboxLastestShelveTime () {
    return doGet('/love/provisions/lastest_shelve_time')
  },
  traceLoveProvision (id, isTrace) {
    return doPost(`/love/provisions/${isTrace ? 'untrace' : 'trace'}`, {
      love_provision_id: id
    })
  },
  getLoveboxCompanies (page, perPage) {
    return doGet('/love/companies', { page, perPage })
  },
  subscribeLoveboxCompany (companyId, report = 1, dsl = 0) {
    return doPost(`/love/companies/${companyId}/subscribe`, {
      report: report ? 1 : 0,
      dsl: dsl ? 1 : 0
    })
  },
  getMyLoveOrders (page, perPage) {
    return doGet(`/love/love_orders?page=${page}&perPage=${perPage}`)
  },
  getLoveOrderDetail (id) {
    return doGet(`/love/love_orders/${id}`)
  },
  batchLoveOrderThanks (thanks) {
    return doPost(`/love/love_order_items/batch_thanks`, {
      thanks
    })
  },
  publishLoveProvision (data) {
    return doPost(`/love/provisions`, data)
  },
  getLoveOrderWithProvisionId (provisionId) {
    return doGet(`/love/provisions/love_order?love_provision_id=${provisionId}`)
  },
  setLoveOrderReceived (orderId) {
    return doPost(`/love/love_orders/${orderId}/setReceived`)
  },
  thankLoveOrder (data) {
    return doPost(`/love/love_orders/thank`, data)
  }
}
